import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import {findSuppliersByQueryString} from "../../utils/requestUtils";
import {UserPermission} from "../../utils/utils";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";
import NewButton from '../common/NewButton';
import TableRowActions from '../common/TableRowActions';
import ListPageLayout from '../common/ListPageLayout';
import { showConfirm, showAlert } from '../../core/dialog';

const apiUrl = Config.apiUrl;
const SupplierList = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [suppliers, setSuppliers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = await findSuppliersByQueryString(query);
            setSuppliers(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    async function deleteSupplier(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/suppliers/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.LIST_SUPPLIER) === false) {
        navigate('/unauthorizedaccess');
    }

    return (
        <ListPageLayout
            tableWidth={580}
            header={
                <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                    <div className="header-label">Consulta de Fornecedores</div>
                    {hasUserPermission(UserPermission.CREATE_SUPPLIER) &&
                        <NewButton className={"new-button"} onClick={() => navigate('/app/supplier')}/>
                    }
                </div>
            }
            filters={
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                </div>
            }
        >
            <table>

                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome
                    </th>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {suppliers.map((supplier, index) => (


                    <tr>
                        <td>
                            <div key={index}>{supplier.code}</div>
                        </td>
                        <td>
                            <div key={index}>{supplier.name}</div>
                        </td>
                        <td>
                            <TableRowActions
                                actions={[
                                    {
                                        key: 'edit',
                                        label: 'Editar',
                                        type: 'edit',
                                        visible: hasUserPermission(UserPermission.EDIT_SUPPLIER),
                                        onClick: () => navigate('/app/supplier?id=' + supplier.id),
                                        buttonProps: {className: 'edit-button'},
                                    },
                                    {
                                        key: 'delete',
                                        label: 'Excluir',
                                        type: 'delete',
                                        visible: hasUserPermission(UserPermission.REMOVE_SUPPLIER),
                                        onClick: async () => {
                                            if (await showConfirm('Deseja realmente excluir?')) {
                                                await deleteSupplier(supplier.id);
                                            }
                                        },
                                    },
                                ]}
                            />
                        </td>

                    </tr>
                ))}
                </tbody>
                {suppliers.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>
        </ListPageLayout>
    );
};

export default SupplierList;
